import {Component, ChangeDetectionStrategy, Input, ViewChild, ChangeDetectorRef, OnInit} from "@angular/core";
import {CompositeFilterDescriptor, FilterDescriptor} from "@progress/kendo-data-query";
import {
	BaseFilterCellComponent,
	ColumnComponent,
	FilterCellWrapperComponent,
	FilterService
} from "@progress/kendo-angular-grid";

import * as _ from "lodash";

const stringOperators = ["eq", "neq", "startswith", "endswith"];

@Component({
	selector: 'cp-grid-input-filter-cell',
	templateUrl: './grid.input.filter.cell.html',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class GridInputFilterCellComponent extends BaseFilterCellComponent{

	@Input() showOperators: boolean = true;
	@Input() column: ColumnComponent;
	@Input() filter: CompositeFilterDescriptor;
	@Input() operator: string = "startswith";
	@Input() debounce: number = 500;

	@ViewChild('filterWrapper',{static:false}) filterWrapperComponent: FilterCellWrapperComponent;

	protected defaultOperators: Array<{ text: string, value: string }>;
	public debounceApplyInputFilter;

	public get currentFilter(): FilterDescriptor {
		return this.filterByField(this.column.field);
	}

	constructor(filterService: FilterService, private changeDetector: ChangeDetectorRef) {
		super(filterService);
		this.debounceApplyInputFilter = _.debounce(this.applyInputFilter.bind(this), this.debounce);
	}

	public onClearFilterClick() {
		this.applyFilter(this.removeFilter(this.column.field));
	}

	public onInputFilterChange(value: any): void {
		this.debounceApplyInputFilter(value);
	}

	public applyInputFilter(value: any): void {
		this.applyFilter(!value || value[this.column.field] === '' ? this.removeFilter(this.column.field) :
			this.updateFilter({
				field: this.column.field,
				operator: this.filterWrapperComponent.currentOperator,
				value: value
			})
		);

		this.changeDetector.markForCheck();
	}
}

